import { FileTextIcon } from "@phosphor-icons/react/dist/csr/FileText";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";
import { Stack } from "@volca/ui/components/ui/stack";
import { AttachmentImage } from "./attachment-image";
import { isImageAttachment, type Attachment } from "./enrich-attachments";

export const AttachmentPreview = ({
  file,
  onClose,
}: {
  file?: Attachment;
  onClose: () => void;
}) => (
  <Dialog
    open={!!file}
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <DialogContent className="max-h-[calc(100dvh-2rem)] w-full overflow-y-auto sm:max-w-4xl">
      <DialogTitle className="pr-8 break-words">{file?.name}</DialogTitle>
      <DialogDescription>
        {file?.size !== undefined
          ? `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(file.size / 1024)} KB`
          : "Attached file"}
      </DialogDescription>
      {file &&
        (isImageAttachment(file) ? (
          <AttachmentImage key={file.id} file={file} expanded />
        ) : (
          <Stack align="center" gap={2} className="py-8 text-subtle">
            <FileTextIcon aria-hidden className="size-12" />
          </Stack>
        ))}
      {!!file?.error && (
        <p role="alert" className="text-sm text-danger">
          {file.error}
        </p>
      )}
      {file?.notUsed && (
        <p className="text-xs font-medium text-danger">Not used by the AI.</p>
      )}
    </DialogContent>
  </Dialog>
);
